import { Button, Card, Checkbox, Col, Form, Grid, Input, InputNumber, InputNumberProps, Modal, notification, Radio, Row, Select, Slider, Space, Spin, Tag, TimePicker } from 'antd';
import * as Api from 'api';
import { CameraPinType } from 'helpers/types';
import React, { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
// import { CATEGORIES } from 'res/constants';
import { SignalCellular0Bar, SignalCellular1Bar, SignalCellular2Bar, SignalCellular3Bar, SignalCellular4Bar } from '@mui/icons-material';
import closedEmptyIcon from 'assets/image/icons/closed_empty.png';
import closedFullIcon from 'assets/image/icons/closed_full.png';
import openEmptyIcon from 'assets/image/icons/open_empty.png';
import openFullIcon from 'assets/image/icons/open_full.png';
import SmartFeederActivity from 'components/camera/smartFeederActivity';
import SmartFeederMap from 'components/camera/smartFeederMap';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment';
import type { Moment } from 'moment';
import classes from './style.module.scss';

dayjs.extend(utc);
dayjs.extend(timezone);

const { useBreakpoint } = Grid;

const SmartFeeder = () => {
  const { md } = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [feeders, setFeeders] = useState<CameraPinType[]>([]);
  const [feeder, setFeeder] = useState<any>(null);
  const [openCategories, setOpenCategories] = React.useState<string[]>(['Other']);
  const [closeCategories, setCloseCategories] = React.useState<string[]>([]);
  const [closeInRain, setCloseInRain] = React.useState<boolean>(false);
  const [openInDry, setOpenInDry] = React.useState<boolean>(false);
  const [selectedCameras, setSelectedCameras] = useState<any[]>([]);
  const [actionStay, setActionStay] = useState(5);
  const [cameras, setCameras] = useState<CameraPinType[]>([]);
  const [cameraGroups, setCameraGroups] = useState<any[]>([]);
  const [feederState, setFeederState] = useState<any>({
    door_position: '',
    rain_sensor: '',
    feed_level: '',
    csq: '',
    dbm: '',
  });
  const [openSunrise, setOpenSunrise] = useState<string>();
  const [closeSunset, setCloseSunset] = useState<string>();
  const [thresholdValue, setThresholdValue] = useState(1);
  const [nonThresholdValue, setNonThresholdValue] = useState(1);
  const [defaultMode, setDefaultMode] = useState<string>('open');
  const [categories, setCategories] = useState([]);
  const [alarmOnOff, setAlarmOnOff] = useState(false);
  const [forceOnOff, setForceOnOff] = useState(false);
  const [feederStatusIcon, setFeederStatusIcon] = useState(closedEmptyIcon);
  const [sunRiseTime, setSunRiseTime] = useState<string>('');
  const [sunSetTime, setSunSetTime] = useState<string>('');
  const [actionByTime, setActionByTime] = useState<string>('Open');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState();
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);

  const { auth: { profile } } = useAuth();
  const [form] = Form.useForm();
  const [actionTime, setActionTime] = useState<Moment | null>(null);
  const [actionTimeString, setActionTimeString] = useState<string>('');
  const handleActionTimeChange = (time: Moment | null, timeString: string) => {
    setActionTime(time);
    setActionTimeString(time ? time.format('HH:mm') : (timeString || ''));
  };

  useEffect(() => {
    loadTemplates();
    loadDFeeders();
    loadCamerasGroups();
    http_load_categories();
  }, []);

  const loadTemplates = () => {
    Api.SMARTFEEDER_TEMPLATE_GET().then(((res: any) => {
      const data = JSON.parse(res.text);
      setTemplate(data[0].id);
      setTemplates(data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const http_load_categories = () => {
    Api.DETECTION_THRESHOLD().then(((res: any) => {
      const data = JSON.parse(res.text);
      const tcategories = data.filter((item) => item.enable == '1');
      const cates = tcategories.map((item) => item.category);
      cates.push('Other');
      setCategories(cates);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const loadCamerasGroups = () => {
    Api.CAMERAS_GROUPS().then(((res: any) => {
      const result = JSON.parse(res.text);
      setCameras(result.cameras);
      setCameraGroups(result.cameraGroups);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const loadDFeeders = () => {
    setLoading(true);
    Api.SMARTFEEDER_ALL().then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      setFeeders(result);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  useEffect(() => {
    if (feeders.length > 0) {
      setFeeder(feeders[0].IMEI);
    }
  }, [feeders]);

  useEffect(() => {
    if (feeder) {
      loadFeederSetting();
      loadFeederStatus();
    }
  }, [feeder]);

  const loadFeederStatus = () => {
    Api.SMARTFEEDER_STATE(feeder).then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      setFeederState(result);
      if (result.door_position == 'Open' || result.door_position == 'open') {
        if (result.feed_level == '>50') {
          setFeederStatusIcon(openFullIcon);
        } else {
          setFeederStatusIcon(openEmptyIcon);
        }
      } else if (result.feed_level == '>50') {
        setFeederStatusIcon(closedFullIcon);
      } else {
        setFeederStatusIcon(closedEmptyIcon);
      }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const getDisplayTime = (unixTimestamp, timezoneStr) => {
    if (!unixTimestamp || unixTimestamp <= 0) return 'Not set';

    try {
      const time = dayjs.unix(unixTimestamp).tz(timezoneStr || 'UTC');
      return time.format('h:mm A');
    } catch (error) {
      return dayjs.unix(unixTimestamp).format('h:mm A');
    }
  };

  const loadFeederSetting = () => {
    setLoading(true);
    Api.SMARTFEEDER_SETTING_GET(feeder).then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      setDefaultMode(result.default_mode);
      setCloseInRain(result.rain_close == '1');
      setOpenInDry(result.dry_open == '1');
      setOpenSunrise(result.open_sunrise);
      setCloseSunset(result.close_sunset);
      setThresholdValue(parseInt(result.target_threshold, 10));
      setNonThresholdValue(parseInt(result.nontarget_threshold, 10));
      setThresholdValue(parseInt(result.target_threshold, 10));
      setNonThresholdValue(parseInt(result.nontarget_threshold, 10));
      setActionStay(result.action_stay);
      setSelectedCameras(result.cameras);
      setOpenCategories(result.open_categories);
      setCloseCategories(result.close_categories);
      setAlarmOnOff(result.alarm == '1');
      setForceOnOff(result.force == '1');

      const loadedActionTime = typeof result.action_time === 'string' ? result.action_time.trim() : '';
      setActionTimeString(loadedActionTime);
      setActionTime(loadedActionTime ? moment(loadedActionTime, 'HH:mm') : null);
      setActionByTime(result.action_by_time);
      const openSunriseTime = getDisplayTime(result.open_sunrise_time, result.timezone);
      setSunRiseTime(openSunriseTime);
      const closeSunsetTime = getDisplayTime(result.close_sunset_time, result.timezone);
      setSunSetTime(closeSunsetTime);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onAllStop = () => {
    const params = {
      IMEI: feeder,
      command: 'all_stop',
    };

    Api.SMARTFEEDER_COMMAND(params).then((res: any) => {
      console.log('command response', res);
      notification.open({
        message: 'The command has been sent.',
      });
    }).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const handleUpdateSuntime = () => {
    const params = {
      IMEI: feeder,
    };

    Api.SMARTFEEDER_UPDATE_SUNTIME(params).then((res: any) => {
      loadFeederSetting();
    }).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onOpen = () => {
    const params = {
      IMEI: feeder,
      command: 'force_open',
    };

    Api.SMARTFEEDER_COMMAND(params).then((res: any) => {
      notification.open({
        message: 'The command has been sent.',
      });
    }).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onClose = () => {
    const params = {
      IMEI: feeder,
      command: 'force_close',
    };

    Api.SMARTFEEDER_COMMAND(params).then((res: any) => {
      notification.open({
        message: 'The command has been sent.',
      });
    }).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onCloseWithAlarm = () => {
    const params = {
      IMEI: feeder,
      command: 'alarm_close',
    };

    Api.SMARTFEEDER_COMMAND(params).then((res: any) => {
      notification.open({
        message: 'The command has been sent.',
      });
    }).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const handleOpenCategories = (values) => {
    const newCloseCategories = [...closeCategories];
    for (let index = 0; index < values.length; index++) {
      const element = values[index];
      const i = newCloseCategories.indexOf(element);
      if (i !== -1) {
        newCloseCategories.splice(i, 1);
      }
    }
    setCloseCategories(newCloseCategories);
    setOpenCategories(values);
  };

  const handleCloseCategories = (values) => {
    const newOpenCategories = [...openCategories];
    for (let index = 0; index < values.length; index++) {
      const element = values[index];
      const i = newOpenCategories.indexOf(element);
      if (i !== -1) {
        newOpenCategories.splice(i, 1);
      }
    }
    setOpenCategories(newOpenCategories);
    setCloseCategories(values);
  };

  const handleSelectCameras = (value) => {
    setSelectedCameras(value);
  };

  const changeFeeder = (value) => {
    console.log(`selected ${value}`);
    setFeeder(value);
  };

  const onSave = () => {
    const params = {
      IMEI: feeder,
      default_mode: defaultMode,
      cameras: selectedCameras,
      open_categories: openCategories,
      close_categories: closeCategories,
      action_stay: actionStay,
      rain_close: closeInRain ? 1 : 0,
      dry_open: openInDry ? 1 : 0,
      open_sunrise: openSunrise,
      close_sunset: closeSunset,
      target_threshold: thresholdValue,
      nontarget_threshold: nonThresholdValue,
      alarm: alarmOnOff ? '1' : '0',
      force: forceOnOff ? '1' : '0',
      action_time: actionTime ? actionTime.format('HH:mm') : actionTimeString,
      action_by_time: actionByTime,
    };
    setLoading(true);
    Api.SMARTFEEDER_SETTING_POST(params).then(((res: any) => {
      setLoading(false);
      loadFeederStatus();
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const onSaveTemplate = () => {
    if (!templateName || templateName.trim() === '') {
      notification.open({
        message: 'Please enter a valid template name.',
      });
      return;
    }
    const params = {
      template_name: templateName,
      IMEI: feeder,
    };
    setLoading(true);
    Api.SMARTFEEDER_TEMPLATE_POST(params).then(((res: any) => {
      setLoading(false);
      loadFeederStatus();
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const onApplyTemplate = () => {
    const params = {
      template,
      IMEI: feeder,
    };
    console.log('aaply->', params);
    setLoading(true);
    Api.SMARTFEEDER_APPLY_TEMPLATE_POST(params).then(((res: any) => {
      setLoading(false);
      loadFeederSetting();
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const onChangeTargetThreshold: InputNumberProps['onChange'] = (newValue) => {
    setThresholdValue(newValue as number);
  };

  const onChangeNonTargetThreshold: InputNumberProps['onChange'] = (newValue) => {
    setNonThresholdValue(newValue as number);
  };

  const getCsqDbmIcon = (csq, dbm) => {
    const intDbm = parseInt(dbm, 10);
    let iconColor = 'green';
    if (intDbm > 100) {
      iconColor = 'red';
    } else if (intDbm > 70) {
      iconColor = 'yellow';
    }
    const intCsq = parseInt(csq, 10);
    if (intCsq >= 25) {
      return <SignalCellular4Bar fontSize="large" style={{ color: iconColor }} />;
    }
    if (intCsq >= 20) {
      return <SignalCellular3Bar fontSize="large" style={{ color: iconColor }} />;
    }
    if (intCsq >= 15) {
      return <SignalCellular2Bar fontSize="large" style={{ color: iconColor }} />;
    }
    if (intCsq >= 10) {
      return <SignalCellular1Bar fontSize="large" style={{ color: iconColor }} />;
    }
    return <SignalCellular0Bar fontSize="large" style={{ color: iconColor }} />;
  };

  const getCameras = (cameraIds) => {
    const relatedCameras = cameras.filter((camera) => cameraIds.includes(camera.id));
    return relatedCameras;
  };

  return (
    <>
      <Row>
        <Col md={10} xs={24}>
          <div className={classes.divSelectFeeder} style={{ padding: md ? 24 : 16 }}>
            <Space>
              <div className={classes.formInputLabel}>Smart Feeder:&nbsp;</div>
              <Select
                size="large"
                className={classes.select}
                onChange={changeFeeder}
                value={feeder}
              >
                {feeders.map((val: any, i) => (
                  <Select.Option key={val.id} value={val.IMEI}>{val.name}</Select.Option>
                ))}
              </Select>
              <Tag>
                {feeder}
              </Tag>
            </Space>
            <Card title="Feeder Status" style={{ marginTop: '8px' }}>
              <div>
                <div className={classes.subContent}>
                  <div style={{ display: 'flex' }}>
                    <Space direction="vertical" size="small" style={{ flex: 1 }}>
                      <div className={classes.formInputLabel}>Door Position&nbsp;:&nbsp;<i>{feederState.door_position.charAt(0).toUpperCase() + feederState.door_position.slice(1)}</i></div>
                      <div className={classes.formInputLabel}>Rain Sensor&nbsp;:&nbsp;<i>{feederState.rain_sensor == 'dry' ? 'Not Raining' : 'Raining'}</i></div>
                      <div className={classes.formInputLabel}>Food Level&nbsp;:&nbsp;<i>{feederState.feed_level == '>50' ? 'Hopper Full' : 'Hopper Low'}</i></div>
                      <div className={classes.formInputLabel}>Signal Strength&nbsp;:&nbsp;{getCsqDbmIcon(feederState.csq, feederState.dbm)}</div>
                    </Space>
                    <Space>
                      <img src={feederStatusIcon} alt="" height="80px" />
                    </Space>
                  </div>
                </div>
                <div style={{ height: '400px' }}>
                  <SmartFeederMap feeder={feeders.filter((f) => f.IMEI == feeder)[0]} cameras={getCameras(selectedCameras)} />
                </div>
              </div>
            </Card>
            <Card title="Manual Control" style={{ marginTop: '8px' }}>
              <p>Please ensure the trough is clear before manual operation.</p>
              <Space wrap>
                <div className={classes.divButton}>
                  <Button type="primary" onClick={onAllStop}>All Stop</Button>
                </div>
                <div className={classes.divButton}>
                  <Button type="primary" onClick={onOpen}>Open</Button>
                </div>
                <div className={classes.divButton}>
                  <Button type="primary" onClick={onClose}>Close</Button>
                </div>
                <div className={classes.divButton}>
                  <Button type="primary" onClick={onCloseWithAlarm}>Close With Alarm</Button>
                </div>
              </Space>
            </Card>
          </div>
        </Col>
        <Col md={14} xs={24}>
          <Card
            title="Automatic Operation"
            style={{ margin: md ? '24px 24px 0 0' : '16px' }}
            extra={(
              <Space>
                <Button type="primary" onClick={() => { setIsApplyModalOpen(true); }} style={{ marginRight: '12px' }}>Apply Template Setting</Button>
                <Button type="primary" onClick={() => { setIsModalOpen(true); }} style={{ marginRight: '12px' }}>Save As Template</Button>
              </Space>
            )}
          >
            <Spin spinning={loading} size="large">
              <p><strong>Use the options below to configure your feeder</strong></p>
              <div style={{ marginBottom: 24 }}>
                <Space>
                  <div><strong>Sunrise time : </strong></div>
                  <div>{sunRiseTime}</div>
                </Space>
                <Space style={{ marginLeft: 24 }}>
                  <div><strong>Sunset time : </strong></div>
                  <div>{sunSetTime}</div>
                </Space>
                <Space style={{ marginLeft: 24 }}>
                  <Button type="primary" onClick={handleUpdateSuntime} style={{ marginRight: '12px' }}>Update suntime</Button>
                </Space>
              </div>
              <Form
                form={form}
                style={{ marginTop: md ? 20 : 0 }}
                layout="vertical"
              >
                <div className={classes.profileItem}>
                  <div style={{ marginBottom: 24 }}>
                    <Space>
                      <div>Default Door Position</div>
                      <Select style={{ width: '250px' }} value={defaultMode} onChange={(value) => setDefaultMode(value)}>
                        <Select.Option value="open">Open</Select.Option>
                        <Select.Option value="close">Closed</Select.Option>
                      </Select>
                    </Space>
                    <p style={{ margin: '4px 12px', color: 'gray' }}>WiseEye recommends using the feeder with the Doors open normally and then closing when and Unwanted Species is detected.</p>
                  </div>
                  <Form.Item label="Cameras/Groups related with this feeder">
                    <Select
                      mode="multiple"
                      placeholder="Please select"
                      value={selectedCameras}
                      onChange={handleSelectCameras}
                    >
                      <Select.OptGroup label="Cameras">
                        {cameras.map((val: any) => (
                          <Select.Option key={val.id} value={val.id}>{val.name}</Select.Option>
                        ))}
                      </Select.OptGroup>
                      <Select.OptGroup label="Camera Groups">
                        {cameraGroups.map((val: any) => (
                          <Select.Option key={val.id} value={`group${val.id}`}>{val.name}</Select.Option>
                        ))}
                      </Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Categories to open">
                    <Select
                      mode="multiple"
                      placeholder="Please select"
                      value={openCategories}
                      onChange={handleOpenCategories}
                    >
                      <Select.OptGroup label="Cameras">
                        {categories.map((val: any) => (
                          <Select.Option key={val} value={val}>{val}</Select.Option>
                        ))}
                      </Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Categories to close">
                    <Select
                      mode="multiple"
                      placeholder="Please select"
                      value={closeCategories}
                      onChange={handleCloseCategories}
                    >
                      <Select.OptGroup label="Cameras">
                        {categories.map((val: any) => (
                          <Select.Option key={val} value={val}>{val}</Select.Option>
                        ))}
                      </Select.OptGroup>
                    </Select>
                    {closeCategories.includes('Other') && <p style={{ margin: '4px 12px', color: 'gray' }}>WiseEye does not recommend adding the &quot;Other&quot; category to the Non Target list. Doing so may result in closing the door more often than desired.</p>}
                  </Form.Item>
                  <Form.Item label="How long should the feeder stay open or closed based on the target and non target species or rain?">
                    <Radio.Group onChange={(e) => setActionStay(e.target.value)} value={actionStay} optionType="button">
                      <Radio.Button value="5">5 minutes</Radio.Button>
                      <Radio.Button value="10">10 minutes</Radio.Button>
                      <Radio.Button value="30">30 minutes later</Radio.Button>
                      <Radio.Button value="60">1 hour later</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                  <div style={{ marginBottom: 24 }}>
                    <Space>
                      <div>Close while raining</div>
                      <Checkbox
                        checked={closeInRain}
                        onChange={(e) => {
                          setCloseInRain(e.target.checked);
                          if (e.target.checked) {
                            setOpenInDry(true);
                          }
                        }}
                      />
                      <div>Open in Dry</div>
                      <Checkbox checked={openInDry} onChange={(e) => setOpenInDry(e.target.checked)} />
                    </Space>
                  </div>
                  <div style={{ marginBottom: 24 }}>
                    <Space>
                      <div>Sunrise Action</div>
                      <Select style={{ width: '250px' }} value={openSunrise} onChange={(value) => setOpenSunrise(value)}>
                        <Select.Option value="0">No Sunrise Action Required</Select.Option>
                        <Select.Option value="1">Open at Sunrise</Select.Option>
                        <Select.Option value="2">Open 15 minutes before Sunrise</Select.Option>
                        <Select.Option value="3">Open 30 minutes before Sunrise</Select.Option>
                      </Select>
                    </Space>
                  </div>
                  <div style={{ marginBottom: 24 }}>
                    <Space>
                      <div>Sunset Action&nbsp;</div>
                      <Select style={{ width: '250px' }} value={closeSunset} onChange={(value) => setCloseSunset(value)}>
                        <Select.Option value="0">No Sunset Action Required</Select.Option>
                        <Select.Option value="1">Close at Sunset</Select.Option>
                        <Select.Option value="2">Close 15 minutes after Sunset</Select.Option>
                        <Select.Option value="3">Close 30 minutes after Sunset</Select.Option>
                      </Select>
                    </Space>
                  </div>
                  <Space style={{ marginBottom: '20px' }}>
                    <div>Select the time for action</div>
                    <TimePicker
                      className={classes.control}
                      size="large"
                      format="HH:mm"
                      placeholder="Select Time"
                      value={actionTime}
                      onChange={handleActionTimeChange}
                    />
                  </Space>
                  <Space style={{ marginBottom: '20px' }}>
                    <div>Action by time</div>
                    <Select style={{ width: '250px' }} value={actionByTime} onChange={(value) => setActionByTime(value)}>
                      <Select.Option value="open">Open</Select.Option>
                      <Select.Option value="close">Close</Select.Option>
                    </Select>
                  </Space>
                  <Form.Item label="Target Threshold">
                    <p style={{ margin: '0px 12px 8px 12px', color: 'gray' }}>How many sequential images are required to trigger the action?</p>
                    <Row>
                      <Col span={12}>
                        <Slider
                          min={1}
                          max={10}
                          onChange={onChangeTargetThreshold}
                          value={typeof thresholdValue === 'number' ? thresholdValue : 1}
                        />
                      </Col>
                      <Col span={4}>
                        <InputNumber
                          min={1}
                          max={10}
                          style={{ margin: '0 16px' }}
                          value={thresholdValue}
                          onChange={onChangeTargetThreshold}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item label="Non Target Threshold">
                    <p style={{ margin: '0px 12px 8px 12px', color: 'gray' }}>How many sequential images are required to trigger the action?</p>
                    <Row>
                      <Col span={12}>
                        <Slider
                          min={1}
                          max={10}
                          onChange={onChangeNonTargetThreshold}
                          value={typeof nonThresholdValue === 'number' ? nonThresholdValue : 1}
                        />
                      </Col>
                      <Col span={4}>
                        <InputNumber
                          min={1}
                          max={10}
                          style={{ margin: '0 16px' }}
                          value={nonThresholdValue}
                          onChange={onChangeNonTargetThreshold}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                  <Space>
                    <div>Alarm On/Off</div>
                    <Checkbox checked={alarmOnOff} onChange={(e) => setAlarmOnOff(e.target.checked)} />

                    <div>Force</div>
                    <Checkbox checked={forceOnOff} onChange={(e) => setForceOnOff(e.target.checked)} />
                  </Space>
                </div>
              </Form>
            </Spin>
            <div className={classes.divButton} style={{ marginTop: '12px' }}>
              <Button type="primary" onClick={onSave}>Save</Button>
            </div>
          </Card>
        </Col>
      </Row>
      <Modal title="Save As Template" visible={isModalOpen} onCancel={() => { setIsModalOpen(false); }} onOk={() => { setIsModalOpen(false); onSaveTemplate(); }} okText="Save">
        <p>Please enter the template name: </p>
        <Input size="large" placeholder="Template Name" onChange={(e) => { setTemplateName(e.target.value); }} />
      </Modal>
      <Modal title="Apply Template" visible={isApplyModalOpen} onCancel={() => { setIsApplyModalOpen(false); }} onOk={() => { setIsApplyModalOpen(false); onApplyTemplate(); }} okText="Apply">
        <p>Please select the template: </p>
        <Select
          size="large"
          className={classes.select}
          onChange={(value) => setTemplate(value)}
          value={template}
        >
          {templates.map((val: any) => (
            <Select.Option key={val.id} value={val.id}>
              {val.name}
            </Select.Option>
          ))}
        </Select>
      </Modal>
      <Row>
        <Col xs={24}>
          <div style={{ padding: md ? 24 : 16 }}>
            <SmartFeederActivity feeder={feeder} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SmartFeeder;
